import { IntegrationIconProps } from './types';

const Ibm = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 10.8667V11.8H6.05405V10.8667H0Z" fill="#1F70C1" />
    <path d="M0 9.93333H6.05405V9H0V9.93333Z" fill="#1F70C1" />
    <path
      d="M6.91892 10.8667V11.8H17.2374C17.1775 11.4697 17.0742 11.1562 16.9342 10.8667H6.91892Z"
      fill="#1F70C1"
    />
    <path
      d="M16.2759 9.93333H6.91892V9H14.0818C14.9299 9 15.7014 9.35435 16.2759 9.93333Z"
      fill="#1F70C1"
    />
    <path
      d="M18.1622 10.8667V11.8H24.0927L23.8456 10.8667H18.1622Z"
      fill="#1F70C1"
    />
    <path
      d="M23.5985 9.93333H18.1622V9H23.3514L23.5985 9.93333Z"
      fill="#1F70C1"
    />
    <path
      d="M26.3166 10.8667L26.0695 11.8H32V10.8667H26.3166Z"
      fill="#1F70C1"
    />
    <path d="M32 9.93333H26.5637L26.8108 9H32V9.93333Z" fill="#1F70C1" />
    <path
      d="M30.2703 12.7333H25.8224L25.5753 13.6667H30.2703V12.7333Z"
      fill="#1F70C1"
    />
    <path
      d="M30.2703 14.6H27.6757H25.3282L25.0811 15.5333L24.834 14.6H22.4865H19.8919V15.5333H22.4865V14.6L22.7748 15.5333H25.0811H27.3874L27.6757 14.6V15.5333H30.2703V14.6Z"
      fill="#1F70C1"
    />
    <path d="M30.2703 16.4667H27.6757V17.4H30.2703V16.4667Z" fill="#1F70C1" />
    <path
      d="M30.2703 18.3333H27.6757V19.2667H30.2703V18.3333Z"
      fill="#1F70C1"
    />
    <path d="M32 20.2H27.6757V21.1333H32V20.2Z" fill="#1F70C1" />
    <path d="M32 22.0667H27.6757V23H32V22.0667Z" fill="#1F70C1" />
    <path d="M0 23H6.05405V22.0667H0V23Z" fill="#1F70C1" />
    <path d="M0 21.1333H6.05405V20.2H0V21.1333Z" fill="#1F70C1" />
    <path
      d="M1.72973 19.2667H4.32432V18.3333H1.72973V19.2667Z"
      fill="#1F70C1"
    />
    <path d="M1.72973 17.4H4.32432V16.4667H1.72973V17.4Z" fill="#1F70C1" />
    <path d="M1.72973 15.5333H4.32432V14.6H1.72973V15.5333Z" fill="#1F70C1" />
    <path
      d="M1.72973 13.6667H4.32432V12.7333H1.72973V13.6667Z"
      fill="#1F70C1"
    />
    <path
      d="M8.64865 12.7333V13.6667H11.2432V12.7333H8.64865Z"
      fill="#1F70C1"
    />
    <path
      d="M14.2703 12.7333V13.6667H17.1006C17.2011 13.3715 17.2655 13.0582 17.2881 12.7333H14.2703Z"
      fill="#1F70C1"
    />
    <path
      d="M19.8919 12.7333V13.6667H24.5869L24.3398 12.7333H19.8919Z"
      fill="#1F70C1"
    />
    <path
      d="M16.6203 14.6H8.64865V15.5333H15.5935C15.9952 15.3023 16.3444 14.9827 16.6203 14.6Z"
      fill="#1F70C1"
    />
    <path
      d="M15.5935 16.4667H8.64865V17.4H16.6203C16.3444 17.0173 15.9952 16.6977 15.5935 16.4667Z"
      fill="#1F70C1"
    />
    <path
      d="M17.1006 18.3333H13.8378V19.2667H17.2881C17.2655 18.9418 17.2011 18.6285 17.1006 18.3333Z"
      fill="#1F70C1"
    />
    <path
      d="M19.8919 19.2667V18.3333H22.4865V19.2667H19.8919Z"
      fill="#1F70C1"
    />
    <path d="M22.4865 20.2H18.1622V21.1333H22.4865V20.2Z" fill="#1F70C1" />
    <path
      d="M24.5045 21.1333L24.2162 20.2H25.9459L25.6577 21.1333H24.5045Z"
      fill="#1F70C1"
    />
    <path d="M22.4865 22.0667H18.1622V23H22.4865V22.0667Z" fill="#1F70C1" />
    <path
      d="M14.0818 23C14.9299 23 15.7014 22.6457 16.2759 22.0667H6.91892V23H14.0818Z"
      fill="#1F70C1"
    />
    <path
      d="M6.91892 21.1333H16.9342C17.0742 20.8438 17.1775 20.5303 17.2374 20.2H6.91892V21.1333Z"
      fill="#1F70C1"
    />
    <path
      d="M8.64865 19.2667H11.2432V18.3333H8.64865V19.2667Z"
      fill="#1F70C1"
    />
    <path
      d="M24.7928 22.0667H25.3694L25.0811 23L24.7928 22.0667Z"
      fill="#1F70C1"
    />
    <path
      d="M26.2342 19.2667H23.9279L23.6396 18.3333H26.5225L26.2342 19.2667Z"
      fill="#1F70C1"
    />
    <path
      d="M26.8108 17.4L27.0991 16.4667H23.0631L23.3514 17.4H26.8108Z"
      fill="#1F70C1"
    />
    <path d="M22.4865 17.4H19.8919V16.4667H22.4865V17.4Z" fill="#1F70C1" />
  </svg>
);
export default Ibm;
